import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginPage from "../Components/Login/Loginpage";
import RegisterPage from "../Components/Login/RegisterPage";
import HomePage from "../Components/HomePage";

import EmailNotificationPage from "../Components/Notify/EmailNotificationPage";
import AccountActivationPage from "../Components/Notify/AccountActivationPage";
import ForgotPass from "../Components/Notify/ForgotPass";
import CreateNewPass from "../Components/Notify/CreateNewPass";
import TermsAndConditionsPage from "../Components/TermsAndPolicy/TermsAndConditionsPage";
import Policy from "../Components/TermsAndPolicy/PolicyPage";

const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<HomePage />} />
        <Route exact path="/about" element={<HomePage />} />
        <Route exact path="/packages" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/emailNotification" element={<EmailNotificationPage />} />
        <Route path="/accountActivation" element={<AccountActivationPage />} />
        <Route path="/forgotPass" element={<ForgotPass />} />
        <Route path="/createNewPass" element={<CreateNewPass />} />
        <Route
          path="/termsAndConditions"
          element={<TermsAndConditionsPage />}
        />
        <Route path="/policy" element={<Policy />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
